import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Air } from "@air/next-icons";
import { Portal } from "@air/primitive-portal";
import Image from "next/legacy/image";
import CatDoingThings from "~/assets/cat-doing-things.svg";
import { MAINTENANCE_MODE_CONTAINER } from "~/constants/testIDs";
import { useFeatureFlags } from "~/hooks/useFeatureFlags";
export const MaintenanceMode = (param)=>{
    let { children } = param;
    const { maintenanceModeJson } = useFeatureFlags();
    if (maintenanceModeJson === null || maintenanceModeJson === void 0 ? void 0 : maintenanceModeJson.maintenanceMessage) {
        return /*#__PURE__*/ _jsx(Portal, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "fixed left-0 top-0 z-10 flex size-full flex-col items-center bg-white px-8",
                "data-testid": MAINTENANCE_MODE_CONTAINER,
                children: [
                    /*#__PURE__*/ _jsx(Air, {
                        className: "my-2 w-[105px] text-blue-9"
                    }),
                    /*#__PURE__*/ _jsx(Image, {
                        alt: "A cat doing things",
                        src: CatDoingThings,
                        height: 295,
                        width: 496
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "max-w-screen-sm",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "mb-4 text-center font-gelica text-40 font-semibold text-grey-12",
                                children: "Air is currently unavailable"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-center text-20 text-grey-10",
                                children: maintenanceModeJson.maintenanceMessage
                            })
                        ]
                    })
                ]
            })
        });
    }
    return children;
};
